import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionBillingDetail extends Layout {
    checkboxProcessed: Checkbox;
    checkboxSubmitted: Checkbox;
    panelLeft: Panel;
    panelMiddle: Panel;
    panelRight: Panel;
    sourceRenditionBilling: DataSource;
    sourceRenditionTypes: DataSource;
    textboxRenbBatchid: Textbox;
    textboxRenbBillTo2: Textbox;
    textboxRenbBillTo: Textbox;
    textboxRenbBillgendt: Textbox;
    textboxRenbBilltype2: Textbox;
    textboxRenbBilltype: Textbox;
    textboxRenbCcinvno: Textbox;
    textboxRenbFilterid: Textbox;
    textboxRenbInvno: Textbox;
    textboxRenbLoadNo: Textbox;
    textboxRenbLogin2: Textbox;
    textboxRenbLogin: Textbox;
    textboxRenbOvrid: Textbox;
    textboxRenbPrintdt: Textbox;
    textboxTypepDesc: Textbox;
    textboxTypepId: Textbox;
}
